import { isEmpty } from 'lodash-es';
import { IConsultantSearchFilterDTO } from 'wisestep-api';

import { IConsultantsSearchFilter, IConsultantsAdvancedFilter } from '../types/IConsultantsSearch';

export const constructActiveConsultantsQuery = (
  data: IConsultantsSearchFilter & IConsultantsAdvancedFilter,
  prevQuery: IConsultantSearchFilterDTO
) => {
  const updatedQuery = prevQuery;
  delete updatedQuery.skills;
  delete updatedQuery.skillsWithExperience;
  delete updatedQuery.willingToRelocate;
  updatedQuery.query = data.query ?? '';
  updatedQuery.locations = data.locations;
  updatedQuery.visaStatus = data.visaStatus;
  updatedQuery.jobTitle = data?.jobTitle?.length ? data?.jobTitle[0] : undefined;
  updatedQuery.availability = data.availability;
  data.fromDate?.setHours(0, 0, 0);
  data.toDate?.setHours(23, 59, 29);
  updatedQuery.updatedFromDate = data.fromDate?.toISOString();
  updatedQuery.updatedToDate = data.toDate?.toISOString();
  updatedQuery.searchInCurrentLocation = !isEmpty(data.locationPreference)
    ? data.locationPreference === 'Current' || data.locationPreference === 'Current or Preferred'
    : true;
  updatedQuery.searchInPreferredLocation = !isEmpty(data.locationPreference)
    ? data.locationPreference === 'Preferred' || data.locationPreference === 'Current or Preferred'
    : true;
  updatedQuery.status = !isEmpty(data.status) ? data.status : undefined;
  if (!isEmpty(data.skills)) {
    updatedQuery.skillsWithExperience = {
      skill: data?.skills?.length ? data?.skills[0] : '',
    };
    updatedQuery.skills = [];
    data.skills?.forEach((skill) => updatedQuery.skills?.push({ text: skill }));
  }
  if (!isEmpty(data.willingToRelocate))
    updatedQuery.willingToRelocate = data.willingToRelocate === 'yes' ? true : false;

  return { ...updatedQuery };
};
